import { Footprints, Car, Bike, Route } from 'lucide-react';
import { LegTravelModeEnum } from '@city-sage/core-client';

/**
 * Get the icon component for a travel mode
 */
export const getTravelModeIcon = (travelMode: LegTravelModeEnum | string) => {
  switch (travelMode) {
    case LegTravelModeEnum.Walking:
    case 'WALKING':
      return Footprints;
    case LegTravelModeEnum.Driving:
    case 'DRIVING':
      return Car;
    case LegTravelModeEnum.Cycling:
    case 'CYCLING':
      return Bike;
    default:
      return Route;
  }
};

/**
 * Get the color for a travel mode (used in maps and UI)
 */
export const getTravelModeColor = (travelMode: string | LegTravelModeEnum): string => {
  switch (travelMode) {
    case LegTravelModeEnum.Walking:
    case 'WALKING':
      return '#10b981'; // green
    case LegTravelModeEnum.Driving:
    case 'DRIVING':
      return '#3b82f6'; // blue
    case LegTravelModeEnum.Cycling:
    case 'CYCLING':
      return '#f59e0b'; // amber
    default:
      return '#6b7280'; // gray
  }
};

/**
 * Format duration in minutes to a human-readable string
 */
export const formatDuration = (minutes: number | null | undefined): string => {
  if (!minutes) return '';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
};

/**
 * Format distance in meters to a human-readable string
 */
export const formatDistance = (meters: number | null | undefined): string => {
  if (!meters) return '';
  if (meters < 1000) return `${meters}m`;
  const km = (meters / 1000).toFixed(1);
  return `${km}km`;
};

/**
 * Get the label for a travel mode
 */
export const getTravelModeLabel = (travelMode: LegTravelModeEnum | string): string => {
  switch (travelMode) {
    case LegTravelModeEnum.Walking:
    case 'WALKING':
      return 'Walking';
    case LegTravelModeEnum.Driving:
    case 'DRIVING':
      return 'Driving';
    case LegTravelModeEnum.Cycling:
    case 'CYCLING':
      return 'Cycling';
    default:
      return 'Unknown';
  }
};


